import {ContentMenuComponent} from './ContentMenuComponent'
import {SwitchTextTypePackage} from './services/switch-text-type/SwitchTextTypePackage'

const ContentMenuPackage = {
    name: 'dw-content-menu',
    configure: function(configurator) {
        configurator.addComponent('dw-content-menu', ContentMenuComponent)

        configurator.addToolGroup('content-menu')
        configurator.addToolGroup('content-top-menu')

        configurator.import(SwitchTextTypePackage)

        configurator.addIcon('content-menu-open', {'fontawesome': 'fa-pencil'})
        configurator.addIcon('content-menu-close', {'fontawesome': 'fa-times'})
    }
}

export {ContentMenuPackage}
